const URL = process.env.REACT_APP_API_URL;

export const DEFAULT_URL = `${URL}/api/v1`;
